import { render, staticRenderFns } from "./ReportContactQuarantine.vue?vue&type=template&id=5302246a"
import script from "./ReportContactQuarantine.vue?vue&type=script&lang=js"
export * from "./ReportContactQuarantine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports